import type {TabRoute} from '../StudentHomepageTabs';

export default function useCurrentTab() {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  let currentTab: TabRoute | 'none' = 'none';

  if (pathname.includes('assignments')) {
    currentTab = 'assignments';
  } else if (pathname.includes('independent-practice')) {
    currentTab = 'independent-practice';
  } else if (pathname.includes('skill-path')) {
    currentTab = 'skill-path';
  }

  return currentTab;
}
